// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"21":"9fdc2522","236":"798720d6","360":"223020a5","381":"41da61e1","383":"3b8046bd","436":"2129733c","509":"91860778","527":"6cb7402f","676":"cb9c324b","688":"2a02b8ef","937":"c88f9103","989":"79887b4e"}[chunkId] + ".js";
};